/*
 *
 * WidgetChartEnps actions
 *
 */

import {
  GET_DATA_NPS_WATCHER,
  GET_DATA_NPS_SUCCESS,
  GET_DATA_NPS_FAILED,
} from "./constants"

export function getDataNpsWatcher(payload) {
  return {
    type: GET_DATA_NPS_WATCHER,
    payload,
  }
}

export function getDataNpsSuccess(payload) {
  return {
    type: GET_DATA_NPS_SUCCESS,
    payload,
  }
}

export function getDataNpsFailed() {
  return { type: GET_DATA_NPS_FAILED }
}
